export async function openBrowserServerWindow(loadURL: () => Promise<string>): Promise<void> {
  const popup = window.open("", "_blank");
  if (!popup) {
    throw new Error("The browser blocked the cloud window");
  }

  try {
    popup.opener = null;
    const url = await loadURL();
    if (popup.closed) {
      throw new Error("The cloud window was closed before navigation");
    }
    popup.location.href = url;
  } catch (error) {
    popup.close();
    throw error;
  }
}
